export const homepageFaqs = [
  {
    id: 1,
    question: "Which is the best restaurant in Salem?",
    answer: "Barbequeen is one of the best restaurants in Salem, serving authentic wood-fire dum biryani, BBQ grills, tandoori, and family meals. Established in 1999, we offer dine-in, takeaway, delivery, and outdoor catering across Salem."
  },
  {
    id: 2,
    question: "Which restaurant serves the best biryani in Salem?",
    answer: "Barbequeen is a popular choice for the best biryani in Salem. Our Chicken, Mutton, and Mandi Biryani are prepared using premium Seeraga Samba rice, traditional dum cooking, and authentic South Indian spices."
  },
  {
    id: 3,
    question: "Which is the best restaurant in Coimbatore?",
    answer: "Barbequeen is one of the best restaurants in Coimbatore, located in Saibaba Colony. We serve authentic biryani, BBQ grills, shawarma, mandi, tandoori, and multi-cuisine dishes in a family-friendly atmosphere."
  },
  {
    id: 4,
    question: "Where can I get the best biryani in Coimbatore?",
    answer: "Looking for the best biryani in Coimbatore? Barbequeen serves freshly prepared Chicken, Mutton, and Bucket Biryani using traditional recipes, premium ingredients, and authentic dum cooking techniques."
  },
  {
    id: 5,
    question: "Which is the best restaurant in Erode?",
    answer: "Barbequeen is one of the best restaurants in Erode, offering authentic biryani, charcoal BBQ, tandoori, Chinese cuisine, and family dining. Visit our branch on Perundurai Road for dine-in, takeaway, or delivery."
  },
  {
    id: 6,
    question: "Where can I find the best biryani in Erode?",
    answer: "Barbequeen is known for serving some of the best biryani in Erode. Enjoy freshly prepared Chicken, Mutton, Family Bucket Biryani, and Mandi made with traditional recipes and premium ingredients."
  },
  {
    id: 7,
    question: "Which restaurant is best for family dining?",
    answer: "Barbequeen is a preferred family restaurant with spacious seating, quality food, and a diverse menu including biryani, BBQ, mandi, Chinese, seafood, and vegetarian dishes for all age groups."
  },
  {
    id: 8,
    question: "Which restaurant is best for birthday celebrations?",
    answer: "Barbequeen is an excellent venue for birthday parties, family gatherings, and corporate events. We offer spacious seating, customized menus, delicious BBQ, authentic biryani, and memorable dining experiences."
  },
  {
    id: 9,
    question: "Does Barbequeen offer BBQ and grilled dishes?",
    answer: "Yes. Barbequeen specializes in charcoal-grilled BBQ, double-marinated chicken, kebabs, tikkas, and premium grill platters, freshly prepared with authentic flavours for dine-in and takeaway."
  },
  {
    id: 10,
    question: "Do you provide outdoor catering services?",
    answer: "Yes. Barbequeen Outdoor Catering has successfully completed over 650 events across Tamil Nadu, offering customized menus, live BBQ counters, and professional catering for weddings, parties, and corporate events."
  },
  {
    id: 11,
    question: "Does Barbequeen offer takeaway and home delivery?",
    answer: "Yes. Most Barbequeen branches offer takeaway and home delivery. Enjoy authentic biryani, BBQ, mandi, shawarma, and other favourites at home, subject to service availability in your location."
  },
  {
    id: 12,
    question: "Why do customers choose Barbequeen?",
    answer: "Customers choose Barbequeen for authentic flavours, fresh ingredients, hygienic cooking, friendly service, and consistent quality. Since 1999, we have been serving memorable dining experiences across Tamil Nadu."
  }
];

export const aboutFaqs = [
  {
    id: 1,
    question: "When was Barbequeen established?",
    answer: "Barbequeen was established in 1999 in Salem, Tamil Nadu. For over 25 years, we have been serving authentic BBQ, wood-fire dum biryani, tandoori, and multi-cuisine dishes with a focus on quality, taste, and hospitality."
  },
  {
    id: 2,
    question: "What makes Barbequeen different from other restaurants?",
    answer: "Barbequeen combines authentic recipes, fresh ingredients, experienced chefs, and warm hospitality to create memorable dining experiences for families, friends, and food lovers across Tamil Nadu."
  },
  {
    id: 3,
    question: "What type of cuisine does Barbequeen serve?",
    answer: "Barbequeen specializes in BBQ grills, authentic dum biryani, tandoori, Arabian mandi, Chinese, Indian, seafood, vegetarian, and non-vegetarian dishes prepared fresh every day."
  },
  {
    id: 4,
    question: "Why is Barbequeen known for its BBQ?",
    answer: "Our signature BBQ is prepared using double-marinated recipes, premium ingredients, and traditional charcoal grilling techniques to deliver rich flavour, tenderness, and consistent quality."
  },
  {
    id: 5,
    question: "Why do families choose Barbequeen?",
    answer: "Families choose Barbequeen for its spacious seating, hygienic food, welcoming ambience, diverse menu, and friendly service, making every meal comfortable and enjoyable."
  },
  {
    id: 6,
    question: "Does Barbequeen use fresh ingredients?",
    answer: "Yes. Every dish is prepared using carefully selected fresh ingredients, premium spices, and quality meats to maintain authentic taste and consistent food quality."
  },
  {
    id: 7,
    question: "Who prepares the food at Barbequeen?",
    answer: "Our experienced chefs specialize in BBQ, biryani, tandoori, Indian, and Chinese cuisine, following standardized recipes and quality practices developed over more than two decades."
  },
  {
    id: 8,
    question: "Does Barbequeen offer outdoor catering?",
    answer: "Yes. Barbequeen Outdoor Catering has successfully catered more than 650 weddings, corporate events, birthday parties, and family celebrations across Tamil Nadu."
  },
  {
    id: 9,
    question: "What is Barbequeen's mission?",
    answer: "Our mission is to serve delicious food with consistent quality, exceptional hospitality, and memorable dining experiences while preserving authentic flavours that families love."
  },
  {
    id: 10,
    question: "What is Barbequeen's vision?",
    answer: "Barbequeen aims to become one of India's most trusted restaurant brands by delivering exceptional food, customer service, and memorable dining experiences across every location."
  },
  {
    id: 11,
    question: "Is Barbequeen suitable for celebrations?",
    answer: "Yes. Barbequeen is a popular choice for birthdays, anniversaries, family gatherings, office parties, and corporate events with customized dining and catering solutions."
  },
  {
    id: 12,
    question: "Why has Barbequeen been trusted since 1999?",
    answer: "For over 25 years, Barbequeen has built its reputation through authentic recipes, consistent quality, hygienic food preparation, and a commitment to customer satisfaction across Tamil Nadu."
  }
];

export const menuFaqs = [
  {
    id: 1,
    question: "What are the most popular dishes at Barbequeen?",
    answer: "Our most popular dishes include Double Marinated Grill Chicken, Chicken Dum Biryani, Mutton Biryani, Arabian Mandi, BBQ Platters, Shawarma, and Tandoori Specials, all prepared fresh with authentic recipes."
  },
  {
    id: 2,
    question: "What type of food does Barbequeen serve?",
    answer: "Barbequeen offers BBQ grills, authentic dum biryani, Arabian mandi, tandoori, Chinese, Indian, shawarma, seafood, soups, breads, and vegetarian dishes for lunch and dinner."
  },
  {
    id: 3,
    question: "What makes Barbequeen's biryani special?",
    answer: "Our biryani is prepared using premium Seeraga Samba rice, fresh ingredients, aromatic spices, and traditional dum cooking to deliver authentic flavour in every serving."
  },
  {
    id: 4,
    question: "What is Double Marinated Grill Chicken?",
    answer: "Double Marinated Grill Chicken is Barbequeen's signature BBQ dish, marinated twice with special herbs and spices before being charcoal grilled for a juicy, smoky flavour."
  },
  {
    id: 5,
    question: "Does Barbequeen serve Arabian Mandi?",
    answer: "Yes. Barbequeen serves authentic Arabian Mandi prepared with fragrant rice, tender chicken or mutton, and traditional Middle Eastern spices for a rich dining experience."
  },
  {
    id: 6,
    question: "Do you have vegetarian dishes?",
    answer: "Yes. Our menu includes vegetarian starters, soups, Chinese dishes, rice, noodles, breads, gravies, and desserts, making Barbequeen suitable for every guest."
  },
  {
    id: 7,
    question: "Do you serve BBQ and tandoori dishes?",
    answer: "Yes. We offer a wide range of charcoal BBQ, kebabs, tikkas, grilled chicken, and traditional tandoori dishes prepared fresh by experienced chefs."
  },
  {
    id: 8,
    question: "Are your dishes prepared fresh?",
    answer: "Yes. Every dish is freshly prepared using quality ingredients, premium spices, and carefully followed recipes to ensure consistent taste and freshness."
  },
  {
    id: 9,
    question: "Do you offer family meals or bucket biryani?",
    answer: "Yes. We serve Family Bucket Biryani, BBQ platters, combo meals, and sharing portions that are ideal for families, friends, and group dining."
  },
  {
    id: 10,
    question: "Can I order food for takeaway or delivery?",
    answer: "Yes. Most Barbequeen branches offer takeaway and home delivery, allowing you to enjoy your favourite biryani, BBQ, mandi, and grilled dishes at home."
  },
  {
    id: 11,
    question: "Which dishes are best for first-time visitors?",
    answer: "First-time guests often enjoy our Double Marinated Grill Chicken, Chicken Dum Biryani, Arabian Mandi, BBQ Platters, Shawarma, and Tandoori Specials."
  },
  {
    id: 12,
    question: "Do you serve lunch and dinner every day?",
    answer: "Yes. Barbequeen is open daily from 11:00 AM to 11:00 PM, serving lunch, dinner, takeaway, and delivery across our restaurant locations."
  }
];

export const franchiseFaqs = [
  {
    id: 1,
    question: "How can I start a Barbequeen franchise?",
    answer: "Starting a Barbequeen franchise is simple. Submit the franchise enquiry form, share your preferred location and business details, and our franchise team will contact you to discuss the next steps."
  },
  {
    id: 2,
    question: "Why choose a Barbequeen franchise?",
    answer: "Barbequeen has been serving customers since 1999 and has built a trusted reputation for BBQ, biryani, and family dining. Our proven business model and operational support help franchise partners grow confidently."
  },
  {
    id: 3,
    question: "Who can apply for a Barbequeen franchise?",
    answer: "Entrepreneurs, business owners, investors, and hospitality professionals interested in operating a restaurant business can apply for a Barbequeen franchise. Previous food industry experience is helpful but not mandatory."
  },
  {
    id: 4,
    question: "Do I need restaurant experience to own a franchise?",
    answer: "No. Restaurant experience is not mandatory. Our team provides guidance throughout the franchise process, helping partners understand operations and brand standards."
  },
  {
    id: 5,
    question: "Does Barbequeen provide franchise support?",
    answer: "Yes. Barbequeen supports franchise partners with business guidance, operational assistance, brand standards, and launch planning to help establish a successful restaurant."
  },
  {
    id: 6,
    question: "Can I choose my preferred franchise location?",
    answer: "Yes. You can mention your preferred city or location in the franchise application. Our team will evaluate the market potential and location suitability before approval."
  },
  {
    id: 7,
    question: "What franchise models does Barbequeen offer?",
    answer: "Barbequeen offers different franchise opportunities based on business requirements and operational needs. Our franchise team will recommend the most suitable model during the consultation process."
  },
  {
    id: 8,
    question: "How long does the franchise approval process take?",
    answer: "The timeline depends on location evaluation, documentation, and project planning. Once your enquiry is received, the franchise team will guide you through each stage of the approval process."
  },
  {
    id: 9,
    question: "What type of locations are suitable for a Barbequeen franchise?",
    answer: "High-street locations, stand-alone buildings, malls, and food courts with good customer visibility and accessibility are generally preferred for a Barbequeen franchise."
  },
  {
    id: 10,
    question: "How do I contact the Barbequeen franchise team?",
    answer: "You can submit the online franchise enquiry form or contact the Barbequeen franchise team directly using the phone number or email provided on the Franchise page."
  },
  {
    id: 11,
    question: "Is Barbequeen expanding across Tamil Nadu and India?",
    answer: "Yes. Barbequeen continues to expand its restaurant network through company-owned and franchise outlets, offering opportunities for entrepreneurs who want to grow with an established food brand."
  },
  {
    id: 12,
    question: "Why invest in a Barbequeen franchise?",
    answer: "A Barbequeen franchise offers the advantage of an established restaurant brand, a loyal customer base, standardized operations, and ongoing business support, making it an attractive opportunity for long-term growth."
  }
];

export const cateringFaqs = [
  {
    id: 1,
    question: "What catering services does Barbequeen provide?",
    answer: "Barbequeen provides outdoor catering for weddings, receptions, birthdays, corporate events, family functions, and special celebrations with customized menus and professional service across Tamil Nadu."
  },
  {
    id: 2,
    question: "Why choose Barbequeen Outdoor Catering?",
    answer: "Barbequeen Outdoor Catering combines over 25 years of culinary experience, quality ingredients, experienced chefs, and reliable event management to deliver memorable catering for every occasion."
  },
  {
    id: 3,
    question: "What events do you cater for?",
    answer: "We cater weddings, receptions, engagement ceremonies, birthday parties, housewarming functions, corporate events, college functions, religious gatherings, and private celebrations of all sizes."
  },
  {
    id: 4,
    question: "Do you provide live BBQ catering?",
    answer: "Yes. Barbequeen offers live BBQ grill counters with freshly prepared grilled chicken, kebabs, tikkas, and other signature barbecue dishes for weddings, parties, and corporate events."
  },
  {
    id: 5,
    question: "Can I customize the catering menu?",
    answer: "Yes. Our catering menus can be customized based on your event, guest count, cuisine preferences, and budget, including biryani, BBQ, tandoori, Indian, Chinese, and vegetarian dishes."
  },
  {
    id: 6,
    question: "Do you provide catering across Tamil Nadu?",
    answer: "Yes. Barbequeen Outdoor Catering serves customers across Tamil Nadu for weddings, family functions, corporate events, and large outdoor celebrations."
  },
  {
    id: 7,
    question: "How many events has Barbequeen catered?",
    answer: "Barbequeen has successfully completed more than 650 outdoor catering events, earning the trust of families, businesses, and event organizers across Tamil Nadu."
  },
  {
    id: 8,
    question: "Do you provide catering for corporate events?",
    answer: "Yes. We offer professional catering for corporate meetings, office celebrations, product launches, conferences, employee events, and business gatherings with customized menu options."
  },
  {
    id: 9,
    question: "Do you provide vegetarian and non-vegetarian catering?",
    answer: "Yes. We offer both vegetarian and non-vegetarian catering with a wide selection of biryani, BBQ, tandoori, Chinese, Indian, seafood, and vegetarian specialties."
  },
  {
    id: 10,
    question: "How can I book Barbequeen Outdoor Catering?",
    answer: "You can book Barbequeen Outdoor Catering by submitting the enquiry form or contacting our catering team by phone or email to discuss your event requirements."
  },
  {
    id: 11,
    question: "How far in advance should I book catering?",
    answer: "We recommend booking your catering as early as possible, especially for weddings, festivals, and weekends, to ensure your preferred event date and menu are available."
  },
  {
    id: 12,
    question: "What makes Barbequeen Catering different?",
    answer: "Barbequeen is known for authentic recipes, fresh ingredients, experienced chefs, customized menus, professional service, and a commitment to making every event successful."
  }
];

export const outletsFaqs = [
  {
    id: 1,
    question: "Where are Barbequeen Restaurant outlets located?",
    answer: "Barbequeen has multiple restaurant outlets across Tamil Nadu, including Salem, Coimbatore, Erode, Hosur, Pudukkottai, and other cities. Visit our Outlets page to find the nearest branch, address, and contact details."
  },
  {
    id: 2,
    question: "Which is the nearest Barbequeen restaurant?",
    answer: "Use our Outlets page to find the nearest Barbequeen restaurant based on your city. Each branch offers authentic biryani, BBQ, tandoori, dine-in, takeaway, and delivery services where available."
  },
  {
    id: 3,
    question: "What are the opening hours of Barbequeen outlets?",
    answer: "Most Barbequeen outlets are open daily from 11:00 AM to 11:00 PM, making it convenient for lunch, dinner, takeaway, and family dining. Please check your preferred outlet for any location-specific timings."
  },
  {
    id: 4,
    question: "Do all Barbequeen outlets serve the same menu?",
    answer: "Most outlets serve Barbequeen's signature BBQ, biryani, tandoori, shawarma, Chinese, and Indian dishes. Menu availability may vary slightly by location and seasonal specials."
  },
  {
    id: 5,
    question: "Can I reserve a table at any Barbequeen outlet?",
    answer: "Yes. You can reserve a table by contacting your preferred Barbequeen outlet or using the online reservation option available on our website."
  },
  {
    id: 6,
    question: "Do all Barbequeen outlets offer takeaway and delivery?",
    answer: "Most Barbequeen outlets provide takeaway and home delivery. Delivery coverage may vary depending on your location and the nearest restaurant."
  },
  {
    id: 7,
    question: "Which Barbequeen outlet is best for family dining?",
    answer: "Every Barbequeen outlet is designed for family dining, offering spacious seating, a welcoming atmosphere, and a menu featuring BBQ, biryani, mandi, tandoori, and multi-cuisine favourites."
  },
  {
    id: 8,
    question: "Which Barbequeen outlet is best for birthday celebrations?",
    answer: "Most Barbequeen outlets are suitable for birthdays, anniversaries, and family gatherings, with group seating and customized dining arrangements available upon request."
  },
  {
    id: 9,
    question: "Do Barbequeen outlets have parking facilities?",
    answer: "Parking availability varies by outlet. Please contact your preferred Barbequeen branch to confirm parking facilities before your visit."
  },
  {
    id: 10,
    question: "Which Barbequeen outlet serves the best biryani?",
    answer: "All Barbequeen outlets follow standardized recipes and quality standards, serving authentic Chicken Dum Biryani, Mutton Biryani, and signature BBQ dishes prepared with fresh ingredients."
  },
  {
    id: 11,
    question: "Can I contact a specific Barbequeen outlet directly?",
    answer: "Yes. Every Barbequeen outlet has its own contact details. Visit the Outlets page to find the phone number, address, and location information for your preferred branch."
  },
  {
    id: 12,
    question: "How do I find the nearest Barbequeen restaurant on Google Maps?",
    answer: "Visit our Outlets page and select your preferred branch to access its address, contact details, and Google Maps location for easy navigation."
  }
];

export const galleryFaqs = [
  {
    id: 1,
    question: "What can I see in the Barbequeen Outlet Gallery?",
    answer: "The Barbequeen Outlet Gallery showcases our restaurant interiors, dining spaces, BBQ stations, signature dishes, family seating, and event setups, helping guests explore the dining experience before visiting."
  },
  {
    id: 2,
    question: "Why should I view the Outlet Gallery before visiting?",
    answer: "Our gallery gives you a preview of the restaurant ambience, seating, food presentation, and overall dining experience, making it easier to choose the right Barbequeen outlet for your visit."
  },
  {
    id: 3,
    question: "Do the gallery photos show actual Barbequeen outlets?",
    answer: "Yes. The Outlet Gallery features photographs of real Barbequeen restaurants, showcasing our interiors, dining areas, signature dishes, and customer-friendly atmosphere across different locations."
  },
  {
    id: 4,
    question: "Can I view the dining ambience before booking a table?",
    answer: "Yes. Our Outlet Gallery lets you explore the restaurant ambience, seating arrangements, and dining environment before making a reservation or visiting your nearest Barbequeen outlet."
  },
  {
    id: 5,
    question: "Does every Barbequeen outlet have a family-friendly atmosphere?",
    answer: "Yes. Every Barbequeen outlet is designed with comfortable seating, a welcoming ambience, and spacious dining areas, making it suitable for families, friends, and group gatherings."
  },
  {
    id: 6,
    question: "Can I see photos of Barbequeen's signature dishes?",
    answer: "Yes. The gallery features popular dishes including BBQ grills, Chicken Dum Biryani, Tandoori Specials, Arabian Mandi, and other customer favourites served at Barbequeen."
  },
  {
    id: 7,
    question: "Does the gallery include photos of private events and celebrations?",
    answer: "Yes. The Outlet Gallery includes selected photos of birthday celebrations, family gatherings, and special dining moments hosted at Barbequeen restaurants."
  },
  {
    id: 8,
    question: "Are the gallery images regularly updated?",
    answer: "Yes. We periodically update our gallery with new restaurant interiors, food photography, customer experiences, and special event highlights from Barbequeen outlets."
  },
  {
    id: 9,
    question: "Can I choose a Barbequeen outlet based on the gallery?",
    answer: "Yes. The gallery helps you compare the ambience and dining spaces across Barbequeen outlets, making it easier to choose the location that best suits your family, friends, or special occasion."
  },
  {
    id: 10,
    question: "Where can I find more photos of Barbequeen restaurants?",
    answer: "You can explore more restaurant photos, food images, and dining experiences in the Barbequeen Outlet Gallery and on our official social media channels."
  },
  {
    id: 11,
    question: "Do the gallery photos reflect the actual dining experience?",
    answer: "Yes. Our gallery highlights the real ambience, signature dishes, hospitality, and dining environment that guests can expect when visiting any Barbequeen outlet."
  },
  {
    id: 12,
    question: "How can I visit the Barbequeen outlet shown in the gallery?",
    answer: "Simply visit our Outlets page to find the branch address, contact details, and directions for the Barbequeen restaurant featured in the gallery."
  }
];

export const contactFaqs = [
  {
    id: 1,
    question: "How can I contact Barbequeen Restaurant?",
    answer: "You can contact Barbequeen by phone, email, or the online contact form. Our customer support team is available to help with reservations, catering, feedback, and general enquiries."
  },
  {
    id: 2,
    question: "What is Barbequeen's customer support number?",
    answer: "You can reach Barbequeen's customer support team by calling +91 95972 28788 during business hours for reservations, enquiries, and customer assistance."
  },
  {
    id: 3,
    question: "What is Barbequeen's email address?",
    answer: "For enquiries, reservations, feedback, or business requests, you can email Barbequeen at feedback@barbequeen.com. Our team will respond as soon as possible."
  },
  {
    id: 4,
    question: "What are Barbequeen's business hours?",
    answer: "Barbequeen is open Monday to Sunday from 11:00 AM to 11:00 PM. Visit your nearest outlet for dine-in, takeaway, reservations, and food orders."
  },
  {
    id: 5,
    question: "Where is Barbequeen's head office located?",
    answer: "Barbequeen's head office is located in Subramaniya Nagar, Salem, Tamil Nadu. Visit our Contact page for the complete address and directions."
  },
  {
    id: 6,
    question: "Can I book a table through the Contact page?",
    answer: "Yes. You can contact our team by phone or submit an enquiry through the Contact page to reserve a table at your preferred Barbequeen outlet."
  },
  {
    id: 7,
    question: "Can I contact Barbequeen for catering enquiries?",
    answer: "Yes. Our team can assist with outdoor catering, weddings, corporate events, birthday parties, and family functions. Simply call or submit your enquiry through the Contact page."
  },
  {
    id: 8,
    question: "How can I share feedback about my dining experience?",
    answer: "We welcome your feedback. You can contact Barbequeen by phone, email, or the online contact form to share your suggestions, compliments, or concerns."
  },
  {
    id: 9,
    question: "Can I contact Barbequeen for franchise enquiries?",
    answer: "Yes. For franchise opportunities, you can contact our franchise team through the Franchise page or reach us using the contact details provided on our website."
  },
  {
    id: 10,
    question: "How quickly will Barbequeen respond to my enquiry?",
    answer: "Our team aims to respond to enquiries as quickly as possible during business hours. Response times may vary depending on the nature of your request."
  },
  {
    id: 11,
    question: "Can I visit Barbequeen without a reservation?",
    answer: "Yes. Walk-in guests are welcome at all Barbequeen outlets. However, reservations are recommended on weekends and public holidays for faster seating."
  },
  {
    id: 12,
    question: "Why should I contact Barbequeen directly?",
    answer: "Contacting Barbequeen directly ensures you receive accurate information about reservations, catering, franchise opportunities, outlet locations, menu enquiries, and customer support from our official team."
  }
];

export const blogFaqs = [
  {
    id: 1,
    question: "What topics does the Barbequeen Blog cover?",
    answer: "The Barbequeen Blog shares articles about BBQ, authentic biryani, grilling tips, restaurant updates, catering ideas, recipes, and dining experiences to help food lovers discover new flavours and expert insights."
  },
  {
    id: 2,
    question: "Why should I read the Barbequeen Blog?",
    answer: "Our blog provides expert food tips, BBQ techniques, recipe inspiration, catering advice, and restaurant updates to help you enjoy authentic flavours and make informed dining choices."
  },
  {
    id: 3,
    question: "Does the Barbequeen Blog share BBQ and grilling tips?",
    answer: "Yes. Our blog features BBQ techniques, grilling methods, cooking tips, and chef-inspired insights to help readers understand the art of authentic barbecue cooking."
  },
  {
    id: 4,
    question: "Can I learn about authentic biryani from the blog?",
    answer: "Yes. We publish articles about dum biryani, traditional cooking methods, premium ingredients, regional flavours, and tips for enjoying authentic biryani."
  },
  {
    id: 5,
    question: "Does the blog include catering and event ideas?",
    answer: "Yes. The Barbequeen Blog shares planning tips for weddings, birthday parties, corporate events, and outdoor catering to help make every celebration memorable."
  },
  {
    id: 6,
    question: "Are new articles published regularly?",
    answer: "Yes. We regularly publish new articles featuring food trends, restaurant news, recipes, seasonal specials, BBQ tips, and dining inspiration for our readers."
  },
  {
    id: 7,
    question: "Who writes the Barbequeen Blog?",
    answer: "Our articles are created by the Barbequeen team using insights from experienced chefs, food experts, and restaurant professionals to provide practical and reliable information."
  },
  {
    id: 8,
    question: "Can I discover Barbequeen's signature dishes through the blog?",
    answer: "Yes. Our blog highlights signature dishes, BBQ specials, dum biryani, tandoori favourites, and seasonal menu recommendations to help you explore the best of Barbequeen."
  },
  {
    id: 9,
    question: "Does the blog help me choose what to order?",
    answer: "Yes. Our articles introduce popular dishes, flavour profiles, chef recommendations, and dining suggestions, making it easier to choose the right meal for every occasion."
  },
  {
    id: 10,
    question: "Is the Barbequeen Blog useful for food lovers?",
    answer: "Absolutely. Whether you enjoy BBQ, biryani, grilling, or family dining, our blog offers useful tips, recipes, and food stories to enhance your dining experience."
  },
  {
    id: 11,
    question: "Can I find restaurant updates on the blog?",
    answer: "Yes. The Barbequeen Blog features restaurant news, outlet updates, special offers, seasonal menus, and brand announcements to keep customers informed."
  },
  {
    id: 12,
    question: "Why is the Barbequeen Blog a trusted food resource?",
    answer: "Our blog is based on Barbequeen's experience since 1999, sharing practical knowledge, authentic recipes, and real restaurant expertise to help readers enjoy great food with confidence."
  }
];
